module.exports = __webpack_public_path__ + "img/popupTitle2.c8ab57e4.png";